import { render, staticRenderFns } from "./CreditosMarcaNoPagar.vue?vue&type=template&id=5844ca1a"
import script from "./CreditosMarcaNoPagar.vue?vue&type=script&lang=js"
export * from "./CreditosMarcaNoPagar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports